export var RateTypes;
(function (RateTypes) {
    RateTypes["FIXED"] = "FIXED";
    RateTypes["FLOAT"] = "FLOAT";
})(RateTypes || (RateTypes = {}));
//# sourceMappingURL=rateType.js.map